(function () {
  'use strict';
  var G = window.LL || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  var currency = G.currency || 'USD';

  function money(cents) {
    var n = Number(cents) || 0;
    try {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: currency, minimumFractionDigits: n % 100 === 0 ? 0 : 2, maximumFractionDigits: 2 }).format(n / 100);
    } catch (e) { return '$' + (n / 100).toFixed(n % 100 === 0 ? 0 : 2); }
  }

  /* ---------- toast ---------- */
  var toastTimer;
  function toast(msg) {
    var t = $('#toast'); if (!t) return;
    t.textContent = msg; t.hidden = false;
    clearTimeout(toastTimer); toastTimer = setTimeout(function () { t.hidden = true; }, 2600);
  }

  /* ---------- drawers ---------- */
  var DRAWERS = ['d-menu', 'd-search', 'd-cart'];
  var lastOpener = null;
  function openDrawer(id, opener) {
    DRAWERS.forEach(function (d) { var el = document.getElementById(d); if (el) el.hidden = d !== id; });
    $$('[aria-controls]').forEach(function (b) { b.setAttribute('aria-expanded', String(b.getAttribute('aria-controls') === id)); });
    $('#scrim').hidden = false;
    document.body.classList.add('lock');
    lastOpener = opener || document.activeElement;
    var el = document.getElementById(id);
    if (id === 'd-search') { setTimeout(function () { var q = $('#q'); if (q) q.focus(); }, 30); }
    else { var f = el && el.querySelector('button, a, input'); if (f) f.focus(); }
  }
  function closeDrawers() {
    DRAWERS.forEach(function (d) { var el = document.getElementById(d); if (el) el.hidden = true; });
    $$('[aria-controls]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    var s = $('#scrim'); if (s) s.hidden = true;
    document.body.classList.remove('lock');
    if (lastOpener && lastOpener.focus) lastOpener.focus();
    lastOpener = null;
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-open]');
    if (opener) {
      e.preventDefault();
      var id = opener.getAttribute('data-open');
      if (id === 'd-cart') refreshCart();
      openDrawer(id, opener);
      return;
    }
    if (e.target.closest('[data-close]') || e.target.id === 'scrim') { closeDrawers(); return; }
    var rm = e.target.closest('[data-remove]');
    if (rm) { e.preventDefault(); changeLine(rm.getAttribute('data-remove'), 0); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawers(); });

  /* ---------- cart (Ajax API) ---------- */
  function renderCart(cart) {
    currency = cart.currency || currency;
    var count = cart.item_count, sub = cart.total_price;
    $$('[data-cart-count]').forEach(function (b) { b.textContent = count; b.hidden = count === 0; });
    var subEl = $('[data-cart-subtotal]'); if (subEl) subEl.textContent = money(sub);

    /* No free-shipping meter: Lost Lovers has no confirmed threshold yet. If one is set later,
       add a [data-ship-meter] element back to snippets/drawers.liquid and read G.freeShipAt here. */

    var box = $('[data-cart-lines]'); if (!box) return;
    if (!cart.items.length) { box.innerHTML = '<p class="empty">Nothing in here yet.</p>'; return; }
    box.innerHTML = cart.items.map(function (it) {
      var img = it.image ? it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=240' : '';
      var variant = it.variant_title && it.variant_title !== 'Default Title' ? esc(it.variant_title) + ' · ' : '';
      return '<div class="line">' +
        '<figure class="ph">' + (img ? '<img class="ps" src="' + esc(img) + '" alt="" loading="lazy">' : '') + '</figure>' +
        '<div><a class="line-nm" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' +
        '<small>' + variant + 'Qty ' + it.quantity + '</small>' +
        '<button type="button" class="link-btn" data-remove="' + esc(it.key) + '">Remove</button></div>' +
        '<span class="price">' + money(it.final_line_price) + '</span></div>';
    }).join('');
  }
  function refreshCart() {
    return fetch(G.cartUrl + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); }).then(renderCart)
      .catch(function () {});
  }
  function changeLine(key, qty) {
    return fetch(G.cartChangeUrl + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
      .then(function (r) { return r.json(); }).then(renderCart)
      .catch(function () { toast('Could not update your bag. Refresh and try again.'); });
  }
  window.addEventListener('pageshow', function (e) { if (e.persisted) refreshCart(); });

  /* ---------- product page ---------- */
  var form = document.getElementById('product-form');
  if (form) {
    var idInput = form.querySelector('[data-variant-id]');
    var optsWrap = form.querySelector('[data-opts]');
    var hint = form.querySelector('[data-hint]');
    var leftNote = form.querySelector('[data-left-note]');
    var atc = document.getElementById('atc');
    var priceEl = document.querySelector('[data-buy-price] .price');
    var variantJsonEl = document.querySelector('[data-variant-json]');
    var atcLabel = atc ? (atc.getAttribute('data-label') || atc.textContent) : '';

    var variants = [];
    if (variantJsonEl) { try { variants = JSON.parse(variantJsonEl.textContent) || []; } catch (e) { variants = []; } }
    var groups = optsWrap ? $$('.opt-block', optsWrap) : [];
    var nOpts = groups.length;
    var selections = [];
    groups.forEach(function (g, gi) {
      var pressed = g.querySelector('.size[aria-pressed="true"]');
      selections[gi] = pressed ? pressed.getAttribute('data-value') : null;
    });
    var picked = nOpts === 0 || selections.every(function (s) { return s != null; });

    function optsOf(v) { return [v.option1, v.option2, v.option3]; }
    function matchesFixed(v, sel) {
      var opts = optsOf(v);
      for (var i = 0; i < sel.length; i++) { if (sel[i] != null && opts[i] !== sel[i]) return false; }
      return true;
    }
    function currentVariant() {
      if (nOpts === 0) return variants[0] || null;
      if (!selections.every(function (s) { return s != null; })) return null;
      for (var i = 0; i < variants.length; i++) { if (matchesFixed(variants[i], selections)) return variants[i]; }
      return null;
    }
    function refreshPillAvailability() {
      groups.forEach(function (g, gi) {
        $$('.size', g).forEach(function (pill) {
          var val = pill.getAttribute('data-value');
          var probe = selections.slice(); probe[gi] = val;
          var ok = variants.some(function (v) { return v.available && matchesFixed(v, probe); });
          pill.disabled = !ok;
          pill.setAttribute('aria-pressed', String(selections[gi] === val));
        });
      });
    }
    function renderPrice(v) {
      if (!priceEl || !v) return;
      var html = money(v.price);
      if (v.compare_at_price && v.compare_at_price > v.price) {
        var off = Math.round((v.compare_at_price - v.price) / v.compare_at_price * 100);
        html += '<s>' + money(v.compare_at_price) + '</s><span class="off">−' + off + '%</span>';
      }
      priceEl.innerHTML = html;
    }
    function updateAtc(v) {
      if (!atc) return;
      if (!v) { atc.disabled = false; atc.textContent = atcLabel; return; }
      if (!v.available) { atc.disabled = true; atc.textContent = 'Sold out'; return; }
      atc.disabled = false;
      atc.textContent = atcLabel + ' · ' + money(v.price);
    }
    function updateLeftNote(v) {
      if (!leftNote) return;
      var low = Number(optsWrap && optsWrap.getAttribute('data-size-low')) || 5;
      if (v && v.inventory_management === 'shopify' && v.inventory_quantity > 0 && v.inventory_quantity <= low) {
        leftNote.hidden = false;
        leftNote.textContent = 'Only ' + v.inventory_quantity + ' left in ' + v.title;
      } else { leftNote.hidden = true; leftNote.textContent = ''; }
    }
    function sync() {
      refreshPillAvailability();
      var v = currentVariant();
      if (v) {
        idInput.value = v.id;
        renderPrice(v);
        try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u); } catch (err) {}
      }
      updateAtc(v);
      updateLeftNote(v);
    }

    if (optsWrap) optsWrap.addEventListener('click', function (e) {
      var b = e.target.closest('.size'); if (!b || b.disabled) return;
      var block = b.closest('.opt-block');
      var gi = groups.indexOf(block);
      if (gi === -1) return;
      selections[gi] = b.getAttribute('data-value');
      picked = selections.every(function (s) { return s != null; });
      if (picked && hint) hint.hidden = true;
      sync();
    });

    sync();

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!atc || atc.disabled) return;
      if (!picked) {
        if (hint) hint.hidden = false;
        if (optsWrap) optsWrap.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      var label = atc.textContent;
      atc.disabled = true; atc.textContent = G.t.adding;
      fetch(G.cartAddUrl + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(idInput.value), quantity: 1 }] }) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add to bag'); return j; }); })
        .then(function () { return refreshCart(); })
        .then(function () { openDrawer('d-cart', atc); })
        .catch(function (err) { toast(err.message); })
        .then(function () { atc.disabled = false; atc.textContent = label; });
    });

    /* sticky add bar: shows once the main button has scrolled above the screen.
       A scroll check, not an IntersectionObserver: jumping straight back to the top never
       crosses the button's edge, so an observer would leave the bar stuck open. */
    var stick = $('[data-stick]');
    if (stick && atc) {
      var ticking = false;
      var updateStick = function () { ticking = false; stick.hidden = atc.getBoundingClientRect().bottom > 0; };
      window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(updateStick); } }, { passive: true });
      updateStick();
      var stickBtn = stick.querySelector('[data-stick-add]');
      if (stickBtn) stickBtn.addEventListener('click', function () {
        if (form.requestSubmit) form.requestSubmit(); else atc.click();
      });
    }

    /* photo counter on phones */
    var track = $('[data-track]'), count = $('[data-count]');
    if (track && count) track.addEventListener('scroll', function () {
      var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
      count.textContent = (i + 1) + ' / ' + track.children.length;
    }, { passive: true });
  }

  /* ---------- sort ---------- */
  $$('[data-autosubmit]').forEach(function (s) { s.addEventListener('change', function () { s.form.submit(); }); });

  /* ---------- predictive search ---------- */
  var q = $('#q'), res = $('#q-res'), searchTimer;
  if (q && res) q.addEventListener('input', function () {
    var v = q.value.trim();
    clearTimeout(searchTimer);
    if (v.length < 2) { res.innerHTML = ''; return; }
    searchTimer = setTimeout(function () {
      fetch(G.searchUrl + '.json?q=' + encodeURIComponent(v) + '&resources[type]=product&resources[limit]=6', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (j) {
          var ps = (j.resources && j.resources.results && j.resources.results.products) || [];
          res.innerHTML = ps.length ? ps.map(function (p) {
            var img = p.image ? '<img class="ps" src="' + esc(p.image) + '" alt="" loading="lazy">' : '';
            return '<a class="card" href="' + esc(p.url) + '"><figure class="ph">' + img + '</figure><span class="card-nm">' + esc(p.title) + '</span><span class="price">' + money(Math.round(Number(p.price) * 100)) + '</span></a>';
          }).join('') : '<p class="empty">Nothing matches “' + esc(v) + '”.</p>';
        })
        .catch(function () {});
    }, 200);
  });
})();
